import React, { useEffect, useState } from 'react';


const Ticker = ({ active, dotInterval=5, max=10, initial='' }) => {

  const [ dots, setDots ] = useState(initial);

  useEffect(() => {
    if (!active) {
      return;
    }

    const interval = setInterval(() => {
      setDots((current) => {
        current += '.';
        if (current.length > max) {
          current = initial;
        }
        return current;
      });
    }, 100 * dotInterval);

    return () => clearInterval(interval);
  }, [ active, dotInterval ]);

  return (
    <div style={{ lineBreak: 'anywhere', minWidth: `${max}ch`, display: 'inline-block', textAlign: 'left' }}> { dots } </div>
  );
};

export default Ticker;
